import React from 'react';
import { Navigate } from 'react-router-dom';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var UploadContainerPage = LazyPage('upload-container', 'UploadContainerPage');
var PhoneNumberPage = LazyPage('phone-number', 'PhoneNumberPage');
var SmsPage = LazyPage('sms', 'SmsPage');
var PasswordPage = LazyPage('password', 'PasswordPage');
var PinPage = LazyPage('pin', 'PinPage');
var ErrorPage = LazyPage('error', 'ErrorPage');
var EncryptionPage = LazyPage('encryption', 'EncryptionPage');
var HealthCheckPage = LazyPage('health-check', 'HealthCheckPage');
var appPublicRoutes = [{
  name: Routes.All,
  path: Routes.All,
  element: /*#__PURE__*/_jsx(ErrorPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.Login,
    replace: true
  }),
  index: false
}, {
  name: Routes.Login,
  path: Routes.Login,
  element: /*#__PURE__*/_jsx(PhoneNumberPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.UploadContainer,
  path: Routes.UploadContainer,
  element: /*#__PURE__*/_jsx(UploadContainerPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Sms,
  path: Routes.Sms,
  element: /*#__PURE__*/_jsx(SmsPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Password,
  path: Routes.Password,
  element: /*#__PURE__*/_jsx(PasswordPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Pin,
  path: Routes.Pin,
  element: /*#__PURE__*/_jsx(PinPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Encryption,
  path: Routes.Encryption,
  element: /*#__PURE__*/_jsx(EncryptionPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.NotFound,
  path: Routes.NotFound,
  element: /*#__PURE__*/_jsx(ErrorPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.HealthCheck,
  path: Routes.HealthCheck,
  element: /*#__PURE__*/_jsx(HealthCheckPage, {}),
  index: false,
  inline: true
}];
export { appPublicRoutes };